import { useQuery } from "react-query";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";

const fetchUserData = async (getAccessTokenSilently) => {
  const token = await getAccessTokenSilently();
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  const apiUrl = process.env.REACT_APP_API_URL || "";

  try {
    const { data } = await axios.get(`${apiUrl}/api/users`, { headers });
    return data;
  } catch (error) {
    // If user doesn't exist (404), return null instead of throwing
    if (error.response?.status === 404) {
      return null;
    }
    throw error;
  }
};

export const useFetchUser = () => {
  const { getAccessTokenSilently } = useAuth0();

  return useQuery("fetchUser", () => fetchUserData(getAccessTokenSilently), {
    enabled: !!getAccessTokenSilently,
    retry: (failureCount, error) => {
      // Don't retry on 404 (user doesn't exist yet)
      if (error?.response?.status === 404) {
        return false;
      }
      // Retry other errors up to 3 times
      return failureCount < 3;
    },
  });
};
